import React, { useCallback } from 'react';
import { LocationSelector } from '../LocationSelector';
import '../layout/HeroSlideshow.css';
import {
  HERO_HEADLINE,
  HERO_SEARCH_LABEL,
  HERO_SEARCH_PLACEHOLDER,
  HERO_SUBHEADLINE,
  HERO_TRUST_LINE,
} from './homePageConstants';
import {
  HERO_COVERAGE_QUALIFIER,
  HERO_COVERAGE_RELEASE_NOTE,
  HERO_STAT_CARDS,
} from '../../constants/publicCoverageCopy';
import './HomePage.css';

interface HomeHeroProps {
  onLocationSelect: (location: string) => void;
  showDevHint?: boolean;
}

const HERO_IMAGE = '/images/slideshow/los-angeles.jpg';

export const HomeHero: React.FC<HomeHeroProps> = ({
  onLocationSelect,
  showDevHint,
}) => {
  const focusSearch = useCallback(() => {
    document.getElementById('home-location-search')?.focus();
  }, []);

  const scrollToMembership = useCallback(() => {
    document.getElementById('public-vs-membership')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <div className="hero-slideshow home-hero">
      <div className="slideshow-container">
        <div
          className="slide active"
          style={{ backgroundImage: `url(${HERO_IMAGE})`, transform: 'translateX(0)' }}
        >
          <div className="slide-overlay" />
          <div className="slide-content home-hero__content">
            <div className="slide-text">
              <h1 className="slide-title">{HERO_HEADLINE}</h1>
              <p className="slide-subtitle">{HERO_SUBHEADLINE}</p>
            </div>

            <div className="slide-actions slide-actions--location home-hero__actions">
              <div className="home-hero__cta-row">
                <button
                  type="button"
                  className="home-hero__cta home-hero__cta--primary"
                  onClick={focusSearch}
                >
                  Explore Your Community
                </button>
                <button
                  type="button"
                  className="home-hero__cta home-hero__cta--secondary"
                  onClick={scrollToMembership}
                >
                  Learn About Membership
                </button>
              </div>

              <h2 className="slide-location-label">{HERO_SEARCH_LABEL}</h2>
              <LocationSelector
                onLocationSelect={onLocationSelect}
                placeholder={HERO_SEARCH_PLACEHOLDER}
                className="hero-location-selector"
                inputId="home-location-search"
              />

              {showDevHint && (
                <p className="home-hero__dev-hint">
                  Database not loaded. Check browser console (F12) for errors.
                </p>
              )}

              <dl className="home-hero__stats" aria-label="Platform highlights">
                {HERO_STAT_CARDS.map((card) => (
                  <div key={card.label}>
                    <dt>{card.mainText}</dt>
                    <dd>{card.label}</dd>
                  </div>
                ))}
              </dl>
              <p className="home-hero__coverage-qualifier">{HERO_COVERAGE_QUALIFIER}</p>
              <p className="home-hero__coverage-release">{HERO_COVERAGE_RELEASE_NOTE}</p>
              <p className="home-hero__trust-line">{HERO_TRUST_LINE}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
